import classNames from 'classnames';
import * as React from 'react';
import { thousands } from '../../formatting.js';
import styles from './Gold.module.scss.js';

var Gold = function (props) {
    var _a;
    return (React.createElement("div", { className: classNames(styles.gold, props.className, (_a = {}, _a[styles.isFlat] = !!props.isFlat, _a)) }, thousands(props.amount)));
};

export { Gold as default };
//# sourceMappingURL=Gold.js.map
